import { Button as AntButton, type ButtonProps as AntButtonProps } from 'antd';
import classNames from 'classnames';

export type ButtonProps = AntButtonProps;

export const Button = (props: ButtonProps) => {
  // class '-leave' to prevent onClick default Ant outline animation
  return <AntButton {...props} className={classNames('-leave', props?.className)} />;
};
